<template>
  <!-- <div class="callback">Callback</div> -->
  <div class="w-full flex justify-center">
      
      <ripple-loader></ripple-loader>
  </div>

</template>

<script>
export default {
  name: 'callback',

  async mounted() {

    // await this.$auth.handleAuthentication(this.$apollo).then((data) => {

    // console.log(`in callback mounted`);
    let result = await this.$auth.handleAuthentication();
  
    // this.sleep(1000);

    //   let userInfo;

            // console.log(`******** calling userInfo`);      


        // userInfo = await this.$auth.getAuthInfo();

        // console.log(`******** key is being saved and it is ${JSON.stringify(userInfo)}`);      


    //     this.sleep(1000);


    // console.log(`user info is ${JSON.stringify(userInfo)}`);

    // console.log(`before redirect`);

    this.$router.replace({ path: '/home', query: { redirected: 'true' }});

    // console.log(`after redirect`);
    // })
  },

  methods: {

    async sleep(ms){
       
        return await new Promise(resolve => setTimeout(resolve, ms));
      }
  }
}
</script>